import { b as w } from "./maps.B3fflUov.js";
import { i as V, b as u, r as n, a as l, f as Z } from "./debounce.F9gDQpy6.js";
import { useDefaultStyles as rr } from "../p-components.useDefaultStyles.js";
var er = Object.prototype;
function B(r) {
  var e = r && r.constructor, o = typeof e == "function" && e.prototype || er;
  return r === o;
}
function tr(r, e) {
  return function(o) {
    return r(e(o));
  };
}
var or = tr(Object.keys, Object), ar = Object.prototype, nr = ar.hasOwnProperty;
function sr(r) {
  if (!B(r))
    return or(r);
  var e = [];
  for (var o in Object(r))
    nr.call(r, o) && o != "constructor" && e.push(o);
  return e;
}
var ir = "[object AsyncFunction]", cr = "[object Function]", ur = "[object GeneratorFunction]", pr = "[object Proxy]";
function _(r) {
  if (!V(r))
    return !1;
  var e = u(r);
  return e == cr || e == ur || e == ir || e == pr;
}
var f = n["__core-js_shared__"], x = function() {
  var r = /[^.]+$/.exec(f && f.keys && f.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function fr(r) {
  return !!x && x in r;
}
var gr = Function.prototype, yr = gr.toString;
function s(r) {
  if (r != null) {
    try {
      return yr.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var br = /[\\^$.*+?()[\]{}|]/g, jr = /^\[object .+?Constructor\]$/, dr = Function.prototype, Tr = Object.prototype, lr = dr.toString, mr = Tr.hasOwnProperty, vr = RegExp(
  "^" + lr.call(mr).replace(br, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ar(r) {
  if (!V(r) || fr(r))
    return !1;
  var e = _(r) ? vr : jr;
  return e.test(s(r));
}
function $r(r, e) {
  return r == null ? void 0 : r[e];
}
function p(r, e) {
  var o = $r(r, e);
  return Ar(o) ? o : void 0;
}
var y = p(n, "DataView"), b = p(n, "Map"), j = p(n, "Promise"), d = p(n, "Set"), T = p(n, "WeakMap"), O = "[object Map]", hr = "[object Object]", P = "[object Promise]", S = "[object Set]", M = "[object WeakMap]", E = "[object DataView]", wr = s(y), xr = s(b), Or = s(j), Pr = s(d), Sr = s(T), a = u;
(y && a(new y(new ArrayBuffer(1))) != E || b && a(new b()) != O || j && a(j.resolve()) != P || d && a(new d()) != S || T && a(new T()) != M) && (a = function(r) {
  var e = u(r), o = e == hr ? r.constructor : void 0, i = o ? s(o) : "";
  if (i)
    switch (i) {
      case wr:
        return E;
      case xr:
        return O;
      case Or:
        return P;
      case Pr:
        return S;
      case Sr:
        return M;
    }
  return e;
});
var Mr = "[object Arguments]";
function I(r) {
  return l(r) && u(r) == Mr;
}
var N = Object.prototype, Er = N.hasOwnProperty, Ir = N.propertyIsEnumerable, kr = I(/* @__PURE__ */ function() {
  return arguments;
}()) ? I : function(r) {
  return l(r) && Er.call(r, "callee") && !Ir.call(r, "callee");
}, Cr = Array.isArray, Dr = 9007199254740991;
function U(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= Dr;
}
function Fr(r) {
  return r != null && U(r.length) && !_(r);
}
function Vr() {
  return !1;
}
var R = typeof exports == "object" && exports && !exports.nodeType && exports, k = R && typeof module == "object" && module && !module.nodeType && module, Br = k && k.exports === R, C = Br ? n.Buffer : void 0, _r = C ? C.isBuffer : void 0, Nr = _r || Vr, Ur = "[object Arguments]", Rr = "[object Array]", Gr = "[object Boolean]", Wr = "[object Date]", zr = "[object Error]", Lr = "[object Function]", qr = "[object Map]", Kr = "[object Number]", Hr = "[object Object]", Jr = "[object RegExp]", Xr = "[object Set]", Qr = "[object String]", Yr = "[object WeakMap]", Zr = "[object ArrayBuffer]", re = "[object DataView]", ee = "[object Float32Array]", te = "[object Float64Array]", oe = "[object Int8Array]", ae = "[object Int16Array]", ne = "[object Int32Array]", se = "[object Uint8Array]", ie = "[object Uint8ClampedArray]", ce = "[object Uint16Array]", ue = "[object Uint32Array]", t = {};
t[ee] = t[te] = t[oe] = t[ae] = t[ne] = t[se] = t[ie] = t[ce] = t[ue] = !0;
t[Ur] = t[Rr] = t[Zr] = t[Gr] = t[re] = t[Wr] = t[zr] = t[Lr] = t[qr] = t[Kr] = t[Hr] = t[Jr] = t[Xr] = t[Qr] = t[Yr] = !1;
function pe(r) {
  return l(r) && U(r.length) && !!t[u(r)];
}
function fe(r) {
  return function(e) {
    return r(e);
  };
}
var G = typeof exports == "object" && exports && !exports.nodeType && exports, c = G && typeof module == "object" && module && !module.nodeType && module, ge = c && c.exports === G, g = ge && Z.process, D = function() {
  try {
    var r = c && c.require && c.require("util").types;
    return r || g && g.binding && g.binding("util");
  } catch {
  }
}(), F = D && D.isTypedArray, ye = F ? fe(F) : pe, be = "[object Map]", je = "[object Set]", de = Object.prototype, Te = de.hasOwnProperty;
function le(r) {
  if (r == null)
    return !0;
  if (Fr(r) && (Cr(r) || typeof r == "string" || typeof r.splice == "function" || Nr(r) || ye(r) || kr(r)))
    return !r.length;
  var e = a(r);
  if (e == be || e == je)
    return !r.size;
  if (B(r))
    return !sr(r).length;
  for (var o in r)
    if (Te.call(r, o))
      return !1;
  return !0;
}
function he({
  tool: r,
  context: e,
  toolKind: o
}) {
  let i, m, v, A;
  const {
    builderMode: W,
    defaultAssets: z,
    deviceViewport: $,
    firstVisitDate: L,
    actions: q,
    hotelTimezone: K,
    hotelTimezoneOffset: H,
    language: J,
    countdownTimestamp: X
  } = e;
  (le(r.theme.styles) || !r.theme.styles) && (r.theme.styles = rr(o));
  const {
    content: {
      modules: Q
    },
    settings: {
      devices: h
    },
    theme: {
      styles: Y
    }
  } = r;
  return o !== w.Note ? i = r.settings.layout : v = r.tokens, o === w.Inliner && (A = r.settings.embedded), h && (m = h[$].position), {
    language: J,
    device: $,
    position: m,
    modules: Q,
    layout: i,
    styles: Y,
    actions: q,
    extraData: {
      builderMode: W,
      firstVisitDate: L,
      hotelTimezone: K,
      hotelTimezoneOffset: H,
      defaultAssets: z,
      countdownTimestamp: X,
      tokens: v
    },
    embedded: A
  };
}
export {
  he as p
};
//# sourceMappingURL=parseToolData.Cn4uX0Ht.js.map
